// key: [English, Arabic]
export const translations = {
  // Brand / common
  'brand.tagline': ['Train with Style', 'تدربي بأناقة'],
  'common.loading': ['Loading...', 'جارٍ التحميل...'],
  'common.saving': ['Saving...', 'جارٍ الحفظ...'],
  'common.cancel': ['Cancel', 'إلغاء'],
  'common.save': ['Save', 'حفظ'],
  'common.notes': ['Notes', 'ملاحظات'],
  'common.email': ['Email', 'البريد الإلكتروني'],
  'common.phone': ['Phone', 'رقم الهاتف'],
  'common.password': ['Password', 'كلمة المرور'],
  'common.location': ['Location', 'الموقع'],
  'common.location_value': ['Bahrain & Saudi Arabia', 'البحرين والمملكة العربية السعودية'],
  'common.required_field': ['This field is required', 'هذا الحقل مطلوب'],
  'common.fill_required': ['Please fill in all required fields', 'يرجى تعبئة جميع الحقول المطلوبة'],
  'common.anonymous': ['Anonymous', 'غير معروف'],
  'common.download_report': ['Download Report', 'تحميل التقرير'],
  'common.something_wrong': ['Something went wrong. Please try again.', 'حدث خطأ ما، يرجى المحاولة مرة أخرى.'],
  'common.toggle_theme': ['Toggle theme', 'تبديل المظهر'],

  // Nav
  'nav.home': ['Home', 'الرئيسية'],
  'nav.programs': ['Programs', 'البرامج'],
  'nav.about': ['About', 'من نحن'],
  'nav.assessment': ['Assessment', 'التقييم'],
  'nav.contact': ['Contact', 'تواصلي معنا'],
  'nav.signin': ['Sign In', 'تسجيل الدخول'],
  'nav.signout': ['Sign Out', 'تسجيل الخروج'],
  'nav.cta': ['Start Your Journey', 'ابدئي رحلتك'],
  'nav.admin': ['Admin', 'لوحة الإدارة'],
  'nav.admin_panel': ['Admin Panel', 'لوحة الإدارة'],
  'nav.dashboard': ['Dashboard', 'لوحتي'],

  // Footer
  'footer.about': ['Premium fitness coaching by Coach Amira. Transform your body and mind with personalized training programs.', 'تدريب لياقة راقٍ مع الكوتش أميرة. غيّري جسدك وروحك ببرامج تدريبية مصممة خصيصاً لكِ.'],
  'footer.navigate': ['Navigate', 'روابط سريعة'],
  'footer.about_coach': ['About Coach Amira', 'عن الكوتش أميرة'],
  'footer.assessment': ['Fitness Assessment', 'تقييم اللياقة'],
  'footer.contact_us': ['Contact Us', 'تواصلي معنا'],
  'footer.contact': ['Contact', 'التواصل'],
  'footer.follow': ['Follow Us', 'تابعينا'],
  'footer.certified': ['Certified By', 'معتمدة من'],
  'footer.rights': ['All rights reserved.', 'جميع الحقوق محفوظة.'],
  'cert.ereps': ['EREPS Approved', 'معتمدة من EREPS'],
  'cert.ifa': ['IFA Certified', 'شهادة IFA'],
  'cert.saudi': ['Saudi Bodybuilding Fed.', 'الاتحاد السعودي لبناء الأجسام'],
  'cert.saudi_full': ['Saudi Bodybuilding Federation', 'الاتحاد السعودي لبناء الأجسام واللياقة'],

  // Categories / intensity
  'cat.all': ['All Programs', 'جميع البرامج'],
  'cat.combat': ['Combat', 'قتالية'],
  'cat.strength': ['Strength', 'قوة'],
  'cat.cardio': ['Cardio', 'كارديو'],
  'cat.mind_body': ['Mind & Body', 'العقل والجسد'],
  'cat.dance': ['Dance', 'رقص'],
  'cat.aqua': ['Aqua', 'مائية'],
  'cat.specialized': ['Specialized', 'متخصصة'],
  'intensity.high': ['High', 'عالية'],
  'intensity.medium': ['Medium', 'متوسطة'],
  'intensity.low': ['Low', 'منخفضة'],

  // Home
  'home.overline': ['Coach Amira — Bahrain & Saudi Arabia', 'الكوتش أميرة — البحرين والسعودية'],
  'home.hero_1': ['Train with', 'تدربي'],
  'home.hero_2': ['Style & Strength', 'بأناقة وقوة'],
  'home.hero_sub': ['Start your journey towards a healthy and enjoyable life with specialized, varied, and safe training programs that suit your needs.', 'ابدئي رحلتك نحو حياة صحية وممتعة مع برامج تدريبية متخصصة ومتنوعة وآمنة، صُممت لتناسب احتياجاتك.'],
  'home.cta_primary': ['Discover Your Path', 'اكتشفي طريقك'],
  'home.cta_secondary': ['View Programs', 'استعرضي البرامج'],
  'home.programs_overline': ['Our Programs', 'برامجنا'],
  'home.programs_1': ['Curated', 'تدريب'],
  'home.programs_2': ['Training', 'منتقى بعناية'],
  'home.view_all': ['View All', 'عرض الكل'],
  'home.view_all_programs': ['View All Programs', 'عرض جميع البرامج'],
  'home.stat_programs': ['Training Programs', 'برنامج تدريبي'],
  'home.stat_clients': ['Happy Clients', 'متدربة سعيدة'],
  'home.stat_years': ['Years Experience', 'سنوات من الخبرة'],
  'home.stat_certs': ['Certifications', 'شهادات معتمدة'],
  'home.stories_overline': ['Success Stories', 'قصص نجاح'],
  'home.stories_1': ['Real', 'تحوّلات'],
  'home.stories_2': ['Transformations', 'حقيقية'],
  'home.cta_overline': ['Ready to Transform?', 'مستعدة للتغيير؟'],
  'home.cta_1': ['Your Journey', 'رحلتك'],
  'home.cta_2': ['Starts Here', 'تبدأ من هنا'],
  'home.cta_sub': ['Take our fitness assessment and get a personalized training recommendation from Coach Amira.', 'أكملي تقييم اللياقة واحصلي على توصية تدريبية مخصصة من الكوتش أميرة.'],
  'home.cta_assessment': ['Take the Assessment', 'ابدئي التقييم'],
  'home.cta_contact': ['Get in Touch', 'تواصلي معنا'],
  'home.partners': ['Certified & Recognized By', 'معتمدة ومعترف بها من'],

  // About
  'about.overline': ['About Coach Amira', 'عن الكوتش أميرة'],
  'about.h_1': ['Where', 'حيث تلتقي'],
  'about.h_2': ['Strength', 'القوة'],
  'about.h_3': ['Meets', 'مع'],
  'about.h_4': ['Elegance', 'الأناقة'],
  'about.p1': ['Coach Amira is a certified fitness professional with over 10 years of experience transforming lives across Bahrain and Saudi Arabia. She specializes in creating personalized training programs that combine physical strength with mental wellness.', 'الكوتش أميرة مدربة لياقة معتمدة بخبرة تزيد على 10 سنوات في تغيير حياة المتدربات في البحرين والمملكة العربية السعودية. تتخصص في تصميم برامج تدريبية شخصية تجمع بين القوة البدنية والصحة النفسية.'],
  'about.p2': ['Her philosophy is simple: fitness should be enjoyable, safe, and empowering. With expertise spanning from combat training to prenatal exercises, she meets every client where they are and guides them to where they want to be.', 'فلسفتها بسيطة: اللياقة يجب أن تكون ممتعة وآمنة ومُلهمة. بخبرة تمتد من التدريب القتالي إلى تمارين الحوامل، تبدأ مع كل متدربة من مستواها الحالي وترافقها حتى تصل إلى هدفها.'],
  'about.years': ['Years of Experience', 'سنوات من الخبرة'],
  'about.cred_overline': ['Credentials', 'الاعتمادات'],
  'about.cred_1': ['Certified', 'تميّز'],
  'about.cred_2': ['Excellence', 'معتمد'],
  'about.ereps_desc': ['European Register of Exercise Professionals - recognized internationally as a qualified fitness professional.', 'السجل الأوروبي لمحترفي التمارين — اعتراف دولي كمدربة لياقة مؤهلة.'],
  'about.ifa_desc': ['International Fitness Association certification, validating advanced knowledge in personal training and group fitness.', 'شهادة الاتحاد الدولي للياقة، تؤكد المعرفة المتقدمة في التدريب الشخصي والتمارين الجماعية.'],
  'about.saudi_desc': ['Officially recognized by the Saudi Arabian Bodybuilding and Fitness Federation.', 'معترف بها رسمياً من الاتحاد السعودي لبناء الأجسام واللياقة البدنية.'],
  'about.phil_overline': ['Training Philosophy', 'فلسفة التدريب'],
  'about.phil_1': ['Be Strong, Because Strength Starts with', 'كوني قوية، فالقوة تبدأ'],
  'about.phil_2': ['the Right Decision', 'بالقرار الصحيح'],
  'about.v1_t': ['Personalized Approach', 'نهج مخصص'],
  'about.v1_d': ['Every body is different. Programs are tailored to your specific goals, fitness level, and health conditions.', 'كل جسد مختلف. تُصمم البرامج وفق أهدافك ومستوى لياقتك وحالتك الصحية.'],
  'about.v2_t': ['Safety First', 'السلامة أولاً'],
  'about.v2_d': ['All exercises are designed with proper form and progression to prevent injuries and ensure long-term results.', 'جميع التمارين مصممة بالأداء الصحيح والتدرّج المناسب لتجنب الإصابات وضمان نتائج تدوم.'],
  'about.v3_t': ['Holistic Wellness', 'عافية متكاملة'],
  'about.v3_d': ['Combining physical training with mental wellness, breathwork, and energy healing for complete transformation.', 'نجمع بين التدريب البدني والصحة النفسية وتمارين التنفس والعلاج بالطاقة لتحوّل متكامل.'],

  // Programs
  'programs.overline': ['Our Programs', 'برامجنا'],
  'programs.h_1': ['Train with', 'تدربي'],
  'programs.h_2': ['Purpose', 'بهدف'],
  'programs.sub': ['Over 15 specialized programs designed by Coach Amira to match every fitness level, goal, and preference.', 'أكثر من 15 برنامجاً متخصصاً صممته الكوتش أميرة ليناسب كل مستوى لياقة وكل هدف وكل تفضيل.'],
  'programs.empty': ['No programs found in this category.', 'لا توجد برامج في هذه الفئة.'],

  // Contact
  'contact.overline': ['Contact', 'التواصل'],
  'contact.h_1': ['Get in', 'تواصلي'],
  'contact.h_2': ['Touch', 'معنا'],
  'contact.sub': ["Have a question or ready to start? Reach out and we'll get back to you as soon as possible.", 'لديكِ سؤال أو مستعدة للبدء؟ راسلينا وسنرد عليكِ في أقرب وقت ممكن.'],
  'contact.name': ['Name', 'الاسم'],
  'contact.subject': ['Subject', 'الموضوع'],
  'contact.message': ['Message', 'الرسالة'],
  'contact.ph_name': ['Your name', 'اسمك'],
  'contact.ph_subject': ["What's this about?", 'موضوع رسالتك'],
  'contact.ph_message': ['Tell us more...', 'اكتبي رسالتك هنا...'],
  'contact.send': ['Send Message', 'إرسال الرسالة'],
  'contact.sending': ['Sending...', 'جارٍ الإرسال...'],
  'contact.success': ["Message sent successfully! We'll get back to you soon.", 'تم إرسال رسالتك بنجاح! سنتواصل معكِ قريباً.'],
  'contact.fail': ['Failed to send message. Please try again.', 'تعذّر إرسال الرسالة، يرجى المحاولة مرة أخرى.'],
  'contact.direct': ['Direct Contact', 'تواصل مباشر'],
  'contact.whatsapp': ['Chat on WhatsApp', 'تحدثي معنا عبر واتساب'],
  'contact.whatsapp_sub': ['Quick response guaranteed', 'رد سريع مضمون'],

  // Auth
  'auth.welcome_back': ['Welcome Back', 'أهلاً بعودتك'],
  'auth.signin_sub': ['Sign in to your Princess4Fitness account', 'سجّلي الدخول إلى حسابك في Princess4Fitness'],
  'auth.forgot_link': ['Forgot password?', 'نسيتِ كلمة المرور؟'],
  'auth.ph_password': ['Enter password', 'أدخلي كلمة المرور'],
  'auth.signin': ['Sign In', 'تسجيل الدخول'],
  'auth.signing_in': ['Signing in...', 'جارٍ تسجيل الدخول...'],
  'auth.no_account': ["Don't have an account?", 'ليس لديكِ حساب؟'],
  'auth.create_one': ['Create one', 'أنشئي حساباً'],
  'auth.fill_all': ['Please fill all fields', 'يرجى تعبئة جميع الحقول'],
  'auth.welcome_toast': ['Welcome back, {name}!', 'أهلاً بعودتك يا {name}!'],
  'auth.join': ['Join Princess4Fitness', 'انضمي إلى Princess4Fitness'],
  'auth.join_sub': ['Create your account to start your fitness journey', 'أنشئي حسابك لتبدئي رحلتك نحو اللياقة'],
  'auth.full_name': ['Full Name', 'الاسم الكامل'],
  'auth.ph_full_name': ['Your full name', 'اسمك الكامل'],
  'auth.ph_min6': ['Min 6 characters', '6 أحرف على الأقل'],
  'auth.create': ['Create Account', 'إنشاء الحساب'],
  'auth.creating': ['Creating Account...', 'جارٍ إنشاء الحساب...'],
  'auth.created': ['Account created successfully!', 'تم إنشاء حسابك بنجاح!'],
  'auth.register_fail': ['Registration failed', 'تعذّر إنشاء الحساب'],
  'auth.have_account': ['Already have an account?', 'لديكِ حساب بالفعل؟'],
  'auth.min6': ['Password must be at least 6 characters', 'يجب ألا تقل كلمة المرور عن 6 أحرف'],
  'auth.forgot_title': ['Forgot Password', 'نسيتِ كلمة المرور'],
  'auth.forgot_sub': ["Enter your email and we'll send you a secure reset link.", 'أدخلي بريدك الإلكتروني وسنرسل لكِ رابطاً آمناً لإعادة التعيين.'],
  'auth.check_email': ['Check Your Email', 'تحققي من بريدك'],
  'auth.sent_sub': ['If an account exists for this email, we sent a reset link. It is valid for 1 hour.', 'إذا كان هناك حساب بهذا البريد، فقد أرسلنا رابط إعادة التعيين. الرابط صالح لمدة ساعة واحدة.'],
  'auth.enter_email': ['Please enter your email', 'يرجى إدخال بريدك الإلكتروني'],
  'auth.send_link': ['Send Reset Link', 'إرسال رابط إعادة التعيين'],
  'auth.didnt_get': ["Didn't get it? Check your spam folder or", 'لم يصلك؟ تحققي من مجلد الرسائل غير المرغوبة أو'],
  'auth.try_again': ['try again', 'حاولي مرة أخرى'],
  'auth.back_signin': ['Back to Sign In', 'العودة لتسجيل الدخول'],
  'auth.new_pass_title': ['Set a New Password', 'تعيين كلمة مرور جديدة'],
  'auth.new_pass_sub': ['Choose a new password for your account.', 'اختاري كلمة مرور جديدة لحسابك.'],
  'auth.new_pass': ['New Password', 'كلمة المرور الجديدة'],
  'auth.confirm_pass': ['Confirm Password', 'تأكيد كلمة المرور'],
  'auth.ph_repeat': ['Repeat password', 'أعيدي كتابة كلمة المرور'],
  'auth.mismatch': ['Passwords do not match', 'كلمتا المرور غير متطابقتين'],
  'auth.update_pass': ['Update Password', 'تحديث كلمة المرور'],
  'auth.updating': ['Updating...', 'جارٍ التحديث...'],
  'auth.updated': ['Password updated. Please sign in.', 'تم تحديث كلمة المرور، يرجى تسجيل الدخول.'],
  'auth.invalid_link': ['This reset link is invalid.', 'رابط إعادة التعيين غير صالح.'],
  'auth.request_new': ['Request a new one', 'اطلبي رابطاً جديداً'],
  'auth.reset_fail': ['Could not reset password', 'تعذّرت إعادة تعيين كلمة المرور'],
  // Backend messages
  'Invalid credentials': ['Invalid email or password', 'البريد الإلكتروني أو كلمة المرور غير صحيحة'],
  'Email already registered': ['Email already registered', 'هذا البريد الإلكتروني مسجل مسبقاً'],
  'This reset link is invalid or has expired': ['This reset link is invalid or has expired', 'رابط إعادة التعيين غير صالح أو منتهي الصلاحية'],
  'Client not found': ['Client not found', 'المتدربة غير موجودة'],

  // Assessment
  'gate.title': ['Create Your Account First', 'أنشئي حسابك أولاً'],
  'gate.sub': ['The fitness assessment is your personal agreement with Coach Amira. Sign in or create a free account so your assessment, signed contract and progress are saved securely to you.', 'تقييم اللياقة هو اتفاقيتك الشخصية مع الكوتش أميرة. سجّلي الدخول أو أنشئي حساباً مجانياً ليُحفظ تقييمك وعقدك الموقّع وتقدّمك بأمان في حسابك.'],
  'gate.b1': ['Receive email updates when your agreement is received and signed', 'تصلك رسالة عند استلام اتفاقيتك وعند توقيعها'],
  'gate.b2': ['Download your signed contract anytime from your dashboard', 'حمّلي عقدك الموقّع في أي وقت من لوحتك'],
  'gate.b3': ['Track your BIA body composition progress with Coach Amira', 'تابعي تطور تكوين جسمك مع الكوتش أميرة'],
  'gate.admin_title': ['Assessment is for Clients', 'التقييم مخصص للمتدربات'],
  'gate.admin_sub': ['You are signed in as the coach. Clients fill the assessment from their own accounts; you can review and edit it from the admin panel.', 'أنتِ مسجلة الدخول بحساب الكوتش. تملأ المتدربات التقييم من حساباتهن، ويمكنك مراجعته وتعديله من لوحة الإدارة.'],
  'q.loading': ['Loading assessment...', 'جارٍ تحميل التقييم...'],
  'q.load_fail': ['Failed to load assessment', 'تعذّر تحميل التقييم'],
  'q.overline': ['Fitness Assessment', 'تقييم اللياقة'],
  'q.meta': ['{n} sections · Approximately 5-10 minutes', '{n} أقسام · حوالي 5-10 دقائق'],
  'q.start': ['Start Assessment', 'ابدئي التقييم'],
  'q.section_of': ['Section {i} of {n}', 'القسم {i} من {n}'],
  'q.terms_title': ['Terms & Conditions', 'شروط وسياسة الاشتراك'],
  'q.terms_text': ['Please read our subscription terms and conditions before submitting your assessment. By checking this box, you confirm that you have read and agree to all terms.', 'يرجى قراءة شروط وسياسة الاشتراك قبل إرسال التقييم. بتحديد هذا المربع، تؤكدين أنكِ قرأتِ جميع الشروط وتوافقين عليها.'],
  'q.read_terms': ['Read Terms & Conditions', 'قراءة الشروط والأحكام'],
  'q.agree_terms': ['I have read and agree to the Terms & Conditions', 'قرأتُ الشروط والأحكام وأوافق عليها'],
  'q.ack_title': ['Disclaimer / Acknowledgment of Responsibility', 'إخلاء مسؤولية / إقرار'],
  'q.ack_accept': ['I acknowledge and accept responsibility', 'أُقرّ وأتحمل المسؤولية'],
  'q.back': ['Back', 'السابق'],
  'q.next': ['Next Section', 'القسم التالي'],
  'q.submit': ['Submit Assessment', 'إرسال التقييم'],
  'q.submitting': ['Submitting...', 'جارٍ الإرسال...'],
  'q.need_terms': ['Please read and accept the Terms & Conditions', 'يرجى قراءة الشروط والأحكام والموافقة عليها'],
  'q.need_ack': ['Please accept the responsibility acknowledgment', 'يرجى الموافقة على إقرار المسؤولية'],
  'q.submitted_toast': ['Assessment submitted successfully!', 'تم إرسال التقييم بنجاح!'],
  'q.submit_fail': ['Failed to submit. Please try again.', 'تعذّر الإرسال، يرجى المحاولة مرة أخرى.'],
  'q.done_title': ['Assessment Submitted', 'تم إرسال التقييم'],
  'q.done_sub': ['Your fitness assessment has been submitted successfully.', 'تم إرسال تقييم لياقتك بنجاح.'],
  'q.signed_badge': ['Signed by Coach Amira — Contract ready', 'تم التوقيع من الكوتش أميرة — العقد جاهز'],
  'q.pending_badge': ["Pending Coach Amira's signature", 'بانتظار توقيع الكوتش أميرة'],
  'q.signed_text': ['Your contract has been signed by Coach Amira. You can now download your copy.', 'وقّعت الكوتش أميرة عقدك، ويمكنكِ الآن تحميل نسختك.'],
  'q.pending_text': ['Coach Amira will review and sign your assessment contract. Once signed, you will be able to download the PDF.', 'ستراجع الكوتش أميرة عقد التقييم وتوقّعه، وبعد التوقيع ستتمكنين من تحميل ملف PDF.'],
  'q.download': ['Download Contract PDF', 'تحميل العقد PDF'],
  'q.awaiting': ['Awaiting Coach Signature', 'بانتظار توقيع الكوتش'],
  'q.contact_coach': ['Contact Coach Amira', 'تواصلي مع الكوتش أميرة'],
  'q.reference': ['Reference', 'الرقم المرجعي'],

  // Terms page
  'terms.overline': ['Terms & Conditions', 'الشروط والأحكام'],
  'terms.title': ['Subscription Terms & Policy', 'شروط وسياسة الاشتراك'],
  'terms.intro': ['Welcome to your training journey! To protect the rights of both parties and provide a smooth, professional experience, please review the following policies:', 'أهلاً بكِ في رحلتك التدريبية! لضمان حقوق الطرفين وتوفير تجربة احترافية سلسة، يرجى الاطلاع على السياسات التالية:'],
  'terms.s1_t': ['Session Structure', 'هيكلة الجلسات'],
  'terms.s1_p': ['Each training session is one hour (60 minutes), including warm-up, the main workout, and cool-down.', 'مدة الجلسة التدريبية ساعة واحدة (60 دقيقة)، وتشمل الإحماء، التمرين الأساسي، والتهدئة.'],
  'terms.s2_t': ['Training Program', 'البرنامج التدريبي'],
  'terms.s2_p': ['Exercises are designed and sent specifically to suit your level. The program is flexible — any session can be adjusted based on your physical and mental readiness on the day.', 'يتم تصميم وإرسال التمارين خصيصاً لتناسب مستواكِ. البرنامج يتميز بالمرونة، حيث يمكن تعديل أي جلسة بناءً على جاهزيتك البدنية والذهنية في نفس اليوم.'],
  'terms.s3_t': ['Cancellation & Scheduling Policy', 'سياسة الإلغاء والجدولة'],
  'terms.s3_a_t': ['Prior Notice', 'الإشعار المسبق'],
  'terms.s3_a_p': ['To cancel or reschedule a session, you must notify me at least 24 hours (one full day) before the session time.', 'في حال الرغبة في إلغاء أو إعادة جدولة الجلسة، يجب إبلاغي قبل موعد الجلسة بـ 24 ساعة على الأقل (يوم كامل).'],
  'terms.s3_b_t': ['Subscriber Rights', 'حقوق المشتركة'],
  'terms.s3_b_p': ['The subscriber may postpone one session (one day), or freeze the subscription for a maximum of one week during the subscription period.', 'يحق للمشتركة تأجيل جلسة واحدة (يوم واحد)، أو تجميد الاشتراك لمدة أسبوع واحد كحد أقصى خلال فترة الاشتراك.'],
  'terms.s3_c_t': ['Session Counting', 'احتساب الجلسات'],
  'terms.s3_c_p': ['Late cancellation (less than 24 hours), no-shows, or using up the postponement and freeze allowance will result in the session being counted as "completed" with no compensation.', 'الإلغاء المتأخر (أقل من 24 ساعة)، أو عدم الحضور، أو استنفاد رصيد التأجيل والتجميد، سيؤدي إلى احتساب الجلسة "منفذة" ولن يتم التعويض عنها.'],
  'terms.s4_t': ['Payment Method', 'آلية الدفع'],
  'terms.s4_p': ['Subscription fees are transferred to the company bank account (the IBAN will be provided to you).', 'يتم تحويل رسوم الاشتراك عبر الحساب البنكي الخاص بالشركة (سيتم تزويدك برقم الآيبان IBAN لاحقاً).'],
  'terms.s5_t': ['Refund Policy', 'سياسة الاسترداد'],
  'terms.s5_p1': ['A refund request is accepted only in the event of a material and proven breach by the club in providing the agreed service, such as closure, cancellation of essential services, or safety violations.', 'يُقبل طلب استرداد رسوم الاشتراك فقط في حال وجود إخلال جوهري ومثبت من قبل النادي بتقديم الخدمة المتفق عليها، مثل الإغلاق، أو إلغاء خدمات أساسية، أو مخالفات سلامة.'],
  'terms.s5_p2': ['Refunds are not accepted for a change of mind, non-use, or personal reasons not attributable to the club.', 'لا يُقبل الاسترداد في حال تغيير الرأي، عدم الاستخدام، أو لأسباب شخصية لا تعود إلى تقصير من النادي.'],
  'terms.s5_law': ['In accordance with the provisions of Bahraini Consumer Protection Law No. 35 of 2012.', 'وذلك وفقًا لأحكام قانون حماية المستهلك البحريني رقم 35 لسنة 2012.'],
  'terms.closing': ["Don't hesitate to contact me if you have any questions or need further clarification on any point.", 'لا تترددي في التواصل معي إذا كان لديكِ أي أسئلة أو بحاجة لمزيد من التوضيح حول أي نقطة.'],

  // BIA fields
  'bia.weight': ['Weight', 'الوزن'],
  'bia.body_fat_pct': ['Body Fat', 'نسبة الدهون'],
  'bia.body_fat_mass': ['Fat Mass', 'كتلة الدهون'],
  'bia.muscle_mass': ['Muscle Mass', 'الكتلة العضلية'],
  'bia.muscle_short': ['Muscle', 'العضلات'],
  'bia.fat_free_mass': ['Fat-Free Mass', 'الكتلة الخالية من الدهون'],
  'bia.total_body_water': ['Body Water', 'ماء الجسم'],
  'bia.body_water_pct': ['Body Water', 'نسبة ماء الجسم'],
  'bia.water_short': ['Water', 'الماء'],
  'bia.bone_mass': ['Bone Mass', 'كتلة العظام'],
  'bia.bmi': ['BMI', 'مؤشر كتلة الجسم'],
  'bia.bmi_short': ['BMI', 'BMI'],
  'bia.bmr': ['BMR', 'معدل الأيض الأساسي'],
  'bia.visceral_fat': ['Visceral Fat', 'الدهون الحشوية'],
  'bia.visceral_short': ['Visc. Fat', 'الدهون الحشوية'],
  'bia.metabolic_age': ['Metabolic Age', 'العمر الأيضي'],
  'bia.metabolic_short': ['Met. Age', 'العمر الأيضي'],
  'bia.protein_pct': ['Protein', 'البروتين'],
  'bia.phase_angle': ['Phase Angle', 'زاوية الطور'],
  'unit.kg': ['kg', 'كغ'],
  'unit.%': ['%', '%'],
  'unit.°': ['°', '°'],
  'unit.': ['', ''],
  'unit.L': ['L', 'لتر'],
  'unit.kcal': ['kcal', 'سعرة'],
  'unit.level': ['level', 'مستوى'],
  'unit.yrs': ['yrs', 'سنة'],
  'unit.kg/m²': ['kg/m²', 'كغ/م²'],
  'chart.core': ['Weight & Body Fat', 'الوزن والدهون'],
  'chart.composition': ['Body Composition', 'تكوين الجسم'],
  'chart.water': ['Hydration', 'الترطيب'],
  'chart.metabolic': ['Metabolic', 'الأيض'],
  'chart.additional': ['Additional', 'مؤشرات إضافية'],
  'bia.sec_core': ['Core Measurements', 'القياسات الأساسية'],
  'bia.sec_core_sub': ['Weight & Body Fat', 'الوزن ونسبة الدهون'],
  'bia.sec_muscle': ['Muscle & Lean Mass', 'العضلات والكتلة الصافية'],
  'bia.sec_muscle_sub': ['Skeletal muscle and fat-free mass', 'العضلات الهيكلية والكتلة الخالية من الدهون'],
  'bia.sec_water': ['Hydration', 'الترطيب'],
  'bia.sec_water_sub': ['Total body water analysis', 'تحليل إجمالي ماء الجسم'],
  'bia.sec_bone': ['Bone & Structure', 'العظام والبنية'],
  'bia.sec_bone_sub': ['Bone mineral content', 'محتوى المعادن في العظام'],
  'bia.sec_metabolic': ['Metabolic Indicators', 'مؤشرات الأيض'],
  'bia.sec_metabolic_sub': ['BMI, BMR, visceral fat, metabolic age', 'مؤشر الكتلة، الأيض الأساسي، الدهون الحشوية، العمر الأيضي'],
  'bia.sec_additional': ['Additional Markers', 'مؤشرات إضافية'],
  'bia.sec_additional_sub': ['Protein and cellular health', 'البروتين وصحة الخلايا'],
  'bia.notes_ph': ['Any notes about this reading...', 'أي ملاحظات حول هذه القراءة...'],
  'bia.save': ['Save BIA Data', 'حفظ بيانات القياس'],
  'bia.need_one': ['Please enter at least one measurement', 'يرجى إدخال قياس واحد على الأقل'],
  'bia.logged': ['BIA data logged successfully!', 'تم حفظ بيانات القياس بنجاح!'],
  'bia.log_fail': ['Failed to log data', 'تعذّر حفظ البيانات'],
  'bia.history': ['BIA History', 'سجل القياسات'],
  'bia.date': ['Date', 'التاريخ'],
  'bia.fat_pct_short': ['Fat %', 'الدهون ٪'],
  'bia.by': ['By', 'بواسطة'],
  'bia.client': ['Client', 'المتدربة'],

  // Dashboard
  'dash.overline': ['Body Composition Dashboard', 'لوحة تكوين الجسم'],
  'dash.welcome': ['Welcome,', 'أهلاً،'],
  'dash.sub': ['Bioelectrical Impedance Analysis (BIA) Tracking', 'متابعة تحليل مكونات الجسم (BIA)'],
  'dash.log': ['Log BIA Reading', 'تسجيل قراءة جديدة'],
  'dash.log_sub': ['Enter your Bioelectrical Impedance Analysis measurements', 'أدخلي قياسات تحليل مكونات الجسم'],
  'dash.load_fail': ['Failed to load dashboard', 'تعذّر تحميل لوحة التحكم'],
  'dash.trends': ['Trends', 'المؤشرات عبر الوقت'],
  'dash.no_data': ['No BIA data yet. Log your first reading to see trends!', 'لا توجد قياسات بعد. سجّلي قراءتك الأولى لمتابعة تطورك!'],
  'dash.latest': ['Latest BIA Reading', 'آخر قراءة'],
  'dash.no_readings': ['No readings yet.', 'لا توجد قراءات بعد.'],
  'dash.recommended': ['Recommended Programs', 'البرامج المقترحة'],
  'dash.take_first': ['Take the fitness assessment first.', 'أكملي تقييم اللياقة أولاً.'],
  'dash.take': ['Take Assessment', 'ابدئي التقييم'],
  'dash.contracts': ['Assessment Contracts', 'عقود التقييم'],
  'dash.contracts_sub': ['Your submitted assessments and their signing status', 'تقييماتك المرسلة وحالة توقيعها'],
  'dash.contract_name': ['Fitness Assessment Contract', 'عقد تقييم اللياقة'],
  'dash.submitted_on': ['Submitted {date}', 'أُرسل في {date}'],
  'dash.signed_by_on': [' · Signed by {name} on {date}', ' · وقّعته {name} في {date}'],
  'dash.signed': ['Signed', 'موقّع'],
  'dash.pending': ['Pending Signature', 'بانتظار التوقيع'],
  'dash.download_pdf': ['Download PDF', 'تحميل PDF'],
  'dash.awaiting': ['Awaiting Coach', 'بانتظار الكوتش'],
  'dash.history_empty': ['No BIA readings yet. Log your first reading to start tracking!', 'لا توجد قراءات بعد. سجّلي قراءتك الأولى لتبدئي المتابعة!'],
  'coach': ['Coach', 'الكوتش'],

  // Admin
  'admin.overline': ['Admin Panel', 'لوحة الإدارة'],
  'admin.h_1': ['Coach', 'لوحة'],
  'admin.h_2': ['Dashboard', 'الكوتش'],
  'admin.tab_overview': ['Overview', 'نظرة عامة'],
  'admin.tab_assessments': ['Assessments', 'التقييمات'],
  'admin.tab_clients': ['Clients', 'المتدربات'],
  'admin.tab_contacts': ['Messages', 'الرسائل'],
  'admin.tab_builder': ['Form Builder', 'منشئ النموذج'],
  'admin.total_clients': ['Total Clients', 'إجمالي المتدربات'],
  'admin.assessments': ['Assessments', 'التقييمات'],
  'admin.new_messages': ['New Messages', 'رسائل جديدة'],
  'admin.programs': ['Programs', 'البرامج'],
  'admin.recent_assessments': ['Recent Assessments', 'أحدث التقييمات'],
  'admin.recent_messages': ['Recent Messages', 'أحدث الرسائل'],
  'admin.no_assessments': ['No assessments yet.', 'لا توجد تقييمات بعد.'],
  'admin.no_messages': ['No messages yet.', 'لا توجد رسائل بعد.'],
  'admin.no_responses': ['No assessment responses yet.', 'لا توجد ردود على التقييم بعد.'],
  'admin.status_new': ['new', 'جديدة'],
  'admin.status_resolved': ['resolved', 'تمت المعالجة'],
  'admin.resolved_toast': ['Marked as resolved', 'تم وضع علامة "تمت المعالجة"'],
  'admin.update_fail': ['Failed to update', 'تعذّر التحديث'],
  'admin.signed_toast': ['Contract signed successfully!', 'تم توقيع العقد بنجاح!'],
  'admin.sign_fail': ['Failed to sign', 'تعذّر التوقيع'],
  'admin.bia_logged_for': ['BIA data logged for {name}', 'تم حفظ القياس للمتدربة {name}'],
  'admin.bia_fail': ['Failed to log BIA data', 'تعذّر حفظ بيانات القياس'],
  'admin.config_saved': ['Assessment configuration saved!', 'تم حفظ إعدادات التقييم!'],
  'admin.save_fail': ['Failed to save', 'تعذّر الحفظ'],
  'admin.col_name': ['Name', 'الاسم'],
  'admin.col_email': ['Email', 'البريد الإلكتروني'],
  'admin.col_phone': ['Phone', 'الهاتف'],
  'admin.col_joined': ['Joined', 'تاريخ الانضمام'],
  'admin.col_actions': ['Actions', 'الإجراءات'],
  'admin.bia_profile': ['BIA Profile', 'ملف القياسات'],
  'admin.report': ['Report', 'التقرير'],
  'admin.password': ['Password', 'كلمة المرور'],
  'admin.no_clients': ['No clients yet.', 'لا توجد متدربات بعد.'],
  'admin.back_clients': ['Back to all clients', 'العودة إلى جميع المتدربات'],
  'admin.latest_full': ['Latest Full BIA Reading', 'آخر قراءة كاملة'],
  'admin.entered_by': ['Entered by {name}', 'أدخلتها {name}'],
  'admin.no_client_bia': ['No BIA readings yet for this client.', 'لا توجد قراءات لهذه المتدربة بعد.'],
  'admin.log_for': ['Log BIA for {name}', 'تسجيل قياس للمتدربة {name}'],
  'admin.log_for_sub': ['Enter BIA measurements for this client', 'أدخلي قياسات تحليل الجسم لهذه المتدربة'],
  'admin.sec_muscle': ['Muscle & Lean', 'العضلات والكتلة الصافية'],
  'admin.sec_bone_met': ['Bone & Metabolic', 'العظام والأيض'],
  'admin.resolve': ['Resolve', 'تمت المعالجة'],
  'admin.builder_title': ['Assessment Form Builder', 'منشئ نموذج التقييم'],
  'admin.builder_sub': ['Edit sections, questions, and conditional logic', 'عدّلي الأقسام والأسئلة والشروط المنطقية'],
  'admin.save_changes': ['Save Changes', 'حفظ التغييرات'],
  'admin.general': ['General Settings', 'الإعدادات العامة'],
  'admin.title_en': ['Title (EN)', 'العنوان (إنجليزي)'],
  'admin.title_ar': ['Title (AR)', 'العنوان (عربي)'],
  'admin.desc_en': ['Description (EN)', 'الوصف (إنجليزي)'],
  'admin.desc_ar': ['Description (AR)', 'الوصف (عربي)'],
  'admin.ack_text': ['Acknowledgment Text', 'نص الإقرار'],
  'admin.ack_en': ['Acknowledgment (EN)', 'الإقرار (إنجليزي)'],
  'admin.ack_ar': ['Acknowledgment (AR)', 'الإقرار (عربي)'],
  'admin.add_section': ['Add Section', 'إضافة قسم'],
  'admin.questions_count': ['{n} questions', '{n} أسئلة'],
  'admin.sec_title_en': ['Section Title (EN)', 'عنوان القسم (إنجليزي)'],
  'admin.sec_title_ar': ['Section Title (AR)', 'عنوان القسم (عربي)'],
  'admin.add_question': ['Add Question', 'إضافة سؤال'],
  'admin.conditional': ['conditional', 'مشروط'],
  'admin.q_en': ['Question (EN)', 'السؤال (إنجليزي)'],
  'admin.q_ar': ['Question (AR)', 'السؤال (عربي)'],
  'admin.type': ['Type', 'النوع'],
  'admin.hint_en': ['Hint (EN)', 'تلميح (إنجليزي)'],
  'admin.hint_ar': ['Hint (AR)', 'تلميح (عربي)'],
  'admin.show_if': ['Show only if (Parent Question)', 'إظهار فقط إذا (السؤال الأساسي)'],
  'admin.always': ['Always show', 'إظهار دائماً'],
  'admin.when_equals': ['When answer equals', 'عندما تكون الإجابة'],
  'admin.eg_yes': ['e.g., yes', 'مثال: yes'],
  'admin.required': ['Required', 'إلزامي'],
  'admin.options': ['Options', 'الخيارات'],
  'admin.english': ['English', 'إنجليزي'],
  'admin.arabic': ['Arabic', 'عربي'],
  'admin.add_option': ['Add Option', 'إضافة خيار'],
  'admin.sign': ['Sign Contract', 'توقيع العقد'],
  'admin.terms_ok': ['Terms & Conditions accepted', 'تمت الموافقة على الشروط والأحكام'],
  'admin.ack_ok': ['Responsibility acknowledged', 'تم إقرار المسؤولية'],
  'admin.signed_by_on': ['Signed by {name} on {date}', 'وقّعته {name} في {date}'],
  'admin.confirm_delete_client': ['Delete {name} and all their data (BIA, assessments, reviews) permanently?', 'هل تريدين حذف {name} وجميع بياناتها (القياسات، التقييمات، الآراء) نهائياً؟'],
  'admin.client_deleted': ['Client deleted', 'تم حذف المتدربة'],
  'admin.set_password': ['Set Password', 'تعيين كلمة المرور'],
  'admin.save_password': ['Save Password', 'حفظ كلمة المرور'],
  'admin.password_updated': ['Password updated for {name}', 'تم تحديث كلمة المرور للمتدربة {name}'],
  'admin.password_fail': ['Failed to update password', 'تعذّر تحديث كلمة المرور'],
  'admin.tab_reviews': ['Reviews', 'آراء المتدربات'],
  'rev.title': ['Share Your Experience', 'شاركينا تجربتك'],
  'rev.sub': ['Write a review about your journey with Coach Amira. It will appear on the home page after approval.', 'اكتبي رأيك عن رحلتك مع الكوتش أميرة. سيظهر في الصفحة الرئيسية بعد الموافقة عليه.'],
  'rev.ph': ['Write your review here (Arabic or English)...', 'اكتبي رأيك هنا (بالعربية أو الإنجليزية)...'],
  'rev.submit': ['Submit Review', 'إرسال الرأي'],
  'rev.sending': ['Sending...', 'جارٍ الإرسال...'],
  'rev.min': ['Please write at least 10 characters', 'يرجى كتابة 10 أحرف على الأقل'],
  'rev.sent': ['Thank you! Your review was sent for approval.', 'شكراً لكِ! تم إرسال رأيك للمراجعة.'],
  'rev.fail': ['Failed to send review', 'تعذّر إرسال الرأي'],
  'rev.mine': ['Your Reviews', 'آراؤك'],
  'rev.status_pending': ['Awaiting approval', 'بانتظار الموافقة'],
  'rev.status_approved': ['Published', 'منشور'],
  'rev.status_hidden': ['Hidden', 'مخفي'],
  'rev.admin_title': ['Client Reviews', 'آراء المتدربات'],
  'rev.admin_sub': ['Approve reviews to show them in the home page success stories, hide or delete them anytime.', 'وافقي على الآراء لعرضها في قصص النجاح بالصفحة الرئيسية، ويمكنك إخفاؤها أو حذفها في أي وقت.'],
  'rev.approve': ['Approve & Show', 'موافقة وعرض'],
  'rev.hide': ['Hide', 'إخفاء'],
  'rev.delete': ['Delete', 'حذف'],
  'rev.confirm_delete': ['Delete this review permanently?', 'هل تريدين حذف هذا الرأي نهائياً؟'],
  'rev.updated': ['Review updated', 'تم تحديث الرأي'],
  'rev.deleted': ['Review deleted', 'تم حذف الرأي'],
  'rev.empty': ['No reviews yet.', 'لا توجد آراء بعد.'],
  'rev.filter_all': ['All', 'الكل'],
  'rev.client_review': ['Client Review', 'رأي متدربة'],
  'qtype.text': ['Text', 'نص'],
  'qtype.number': ['Number', 'رقم'],
  'qtype.textarea': ['Long Text', 'نص طويل'],
  'qtype.radio': ['Single Choice', 'اختيار واحد'],
  'qtype.checkbox': ['Multiple Choice', 'اختيار متعدد'],
  'qtype.date': ['Date', 'تاريخ'],
  'qtype.scale': ['Scale (1-10)', 'مقياس (1-10)'],
};
